/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HistoryOutlined, HomeOutlined } from '@ant-design/icons'

import { useFilters, useGeneral, useUser } from '@contexts'
import { useGetConfigurationsData, useLogout } from '@hooks'

import { StyledMenu } from './components'
import { PATHS, RoleEnum } from '../../../types'

const SupplierMenu: () => JSX.Element = () => {
  const { pathname } = useLocation()
  const { logout } = useLogout()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { state: user } = useUser()
  const { setTicketToSearch } = useGeneral()
  const { resetFilters } = useFilters()
  const supplierPaths = user?.roles?.some(r => r.name === RoleEnum.COMMERCIAL)
    ? PATHS.COMMERCIAL
    : PATHS.SUPPLIER

  const { dataConfiguration } = useGetConfigurationsData()
  let tokenExpirationSeconds: number

  const clearFiltersOnComponentChange = () => {
    setTicketToSearch(undefined)
    resetFilters()
  }
  const handleClickRequests = () => {
    navigate(supplierPaths.HOME)
    clearFiltersOnComponentChange()
  }
  const handleClickPrevious = () => {
    navigate(supplierPaths.PREVIOUS)
    clearFiltersOnComponentChange()
  }

  const items = useMemo(
    () => [
      {
        key: supplierPaths.HOME,
        onClick: handleClickRequests,
        icon: <HomeOutlined style={{ fontSize: '18px' }} />,
        label: t('suppliers_router.menu.requests'),
      },
      {
        key: supplierPaths.PREVIOUS,
        onClick: handleClickPrevious,
        icon: <HistoryOutlined />,
        label: t('suppliers_router.menu.previous'),
      },
    ],
    [pathname, supplierPaths.HOME, supplierPaths.PREVIOUS, t],
  )

  useEffect(() => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < dataConfiguration?.configurationProperties.length; i++) {
      if (dataConfiguration?.configurationProperties[i].key === 'TOKEN_EXPIRATION_SECONDS') {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        tokenExpirationSeconds = dataConfiguration?.configurationProperties[i].value
        break
      }
    }

    setTimeout(() => {
      if (tokenExpirationSeconds !== undefined) {
        logout()
      }
    }, (tokenExpirationSeconds - 1) * 1000)
  }, [dataConfiguration])

  return <StyledMenu selectedKeys={[pathname]} mode="inline" items={items} />
}

export { SupplierMenu }
